import React from 'react';

function IdCard({ size, strokeWidth, stroke, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path
        d="M16.8749 26.3815C14.6249 25.8752 14.6249 25.0877 14.6249 24.5252V23.6815C15.1508 23.1828 15.5674 22.5803 15.8482 21.9122C16.129 21.244 16.2679 20.5248 16.2562 19.8002V17.269C16.2488 16.7666 16.1426 16.2707 15.9436 15.8094C15.7445 15.3481 15.4566 14.9306 15.0962 14.5806C14.7358 14.2306 14.3099 13.9551 13.843 13.7697C13.3761 13.5843 12.8772 13.4928 12.3749 13.5002C11.8679 13.4852 11.363 13.5712 10.8896 13.7532C10.4161 13.9352 9.98361 14.2096 9.61719 14.5603C9.25077 14.911 8.95776 15.3311 8.75522 15.7961C8.55267 16.2611 8.44464 16.7618 8.4374 17.269V19.8002C8.43279 20.529 8.58053 21.2507 8.87112 21.9191C9.16172 22.5875 9.58877 23.1878 10.1249 23.6815V24.5252C10.1249 25.0315 10.1249 25.8752 7.7624 26.3815C5.3999 26.8877 5.6249 29.2502 5.6249 29.2502H19.1249C19.1405 28.5853 18.9246 27.9357 18.5142 27.4124C18.1038 26.8891 17.5243 26.5247 16.8749 26.3815V26.3815Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        stroke={stroke}
        strokeWidth={strokeWidth}
        d="M20.25 5.625H34.875V33.75H1.125V5.625H15.75"
        strokeLinecap="round"
      />
      <path
        stroke={stroke}
        strokeWidth={strokeWidth}
        d="M15.75 2.25H20.25V9H15.75V2.25Z"
        strokeLinecap="round"
      />
      <path
        stroke={stroke}
        strokeWidth={strokeWidth}
        d="M21.375 22.5H29.25M21.375 13.5H30.375H21.375ZM21.375 18H27H21.375Z"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default IdCard;
